// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ptdjtgonyxilanijzugt.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB0ZGp0Z29ueXhpbGFuaWp6dWd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQxNTM1MjMsImV4cCI6MjA1OTcyOTUyM30.0dJbiQfJ5OLGGf6FEzrm0FSvwjQIxkiCddvrqakJxlU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Use cookie-based storage only on *.doyencegroup.com so that the auth session
// can be shared across subdomains (admin.doyencegroup.com <-> app.doyencegroup.com)
// for impersonation handoff. On Lovable preview, localhost, or any other host,
// fall back to localStorage so auth keeps working in dev/preview environments.
const isDoyenceHost = (): boolean => {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host === 'doyencegroup.com' || host.endsWith('.doyencegroup.com');
};

const COOKIE_MAX_AGE = 2592000; // 30 days, matches Supabase refresh token lifetime

const cookieStorage = {
  getItem: (key: string): string | null => {
    const match = document.cookie
      .split('; ')
      .find((row) => row.startsWith(`${encodeURIComponent(key)}=`));
    return match ? decodeURIComponent(match.split('=')[1]) : null;
  },
  setItem: (key: string, value: string): void => {
    document.cookie = `${encodeURIComponent(key)}=${encodeURIComponent(value)}; domain=.doyencegroup.com; path=/; max-age=${COOKIE_MAX_AGE}; SameSite=Lax; Secure`;
  },
  removeItem: (key: string): void => {
    document.cookie = `${encodeURIComponent(key)}=; domain=.doyencegroup.com; path=/; max-age=0; SameSite=Lax; Secure`;
  },
};

const storage = isDoyenceHost() ? cookieStorage : localStorage;

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage,
    persistSession: true,
    autoRefreshToken: true,
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
});
